import { ActionIcon, Group, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { MoonIcon, SunIcon, TranslateIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

const ComponentTheme: React.FC = () => {
    /**
     * Hooks
     */
    const computedColorScheme = useComputedColorScheme();

    const { toggleColorScheme } = useMantineColorScheme();

    const { i18n } = useTranslation();

    return (
        <Group>
            <ActionIcon variant="transparent" onClick={() => i18n.changeLanguage(i18n.language === 'zh' ? 'en' : 'zh')}>
                <TranslateIcon size={24} />
            </ActionIcon>

            <ActionIcon variant="transparent" onClick={toggleColorScheme}>
                {computedColorScheme === 'dark' ? <SunIcon size={24} /> : <MoonIcon size={24} />}
            </ActionIcon>
        </Group>
    );
};

export default ComponentTheme;
